import { useContext } from 'react';
import { ParticipantContext } from '~twilio/components/participant-provider';

export default function useParticipantsContext() {
  const context = useContext(ParticipantContext);
  if (!context) {
    throw new Error(
      'useParticipantContext must be used within a ParticipantProvider'
    );
  }
  return context;
}
